import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const WORK_RATE_OPTIONS = [
  { value: 1, label: '×1.0 — ปกติ' },
  { value: 1.5, label: '×1.5 — พิเศษ' },
  { value: 2, label: '×2.0 — วันหยุด' },
  { value: 3, label: '×3.0 — วันหยุดนักขัตฤกษ์' },
];

const OV = { position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center' };
const MO = { background: '#fff', borderRadius: 8, maxWidth: 420, width: 'calc(100% - 32px)', maxHeight: '90vh', overflowY: 'auto' };
const MH = { padding: '14px 20px', borderBottom: '1px solid #e5e7eb' };
const MB = { padding: '16px 20px' };
const MF = { padding: '12px 20px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' };
const IS = { width: '100%', boxSizing: 'border-box', padding: '6px 10px', borderRadius: 4, border: '1px solid #d1d5db', fontSize: '0.875rem', outline: 'none' };
const BP = { padding: '6px 16px', borderRadius: 4, border: 'none', backgroundColor: '#1976d2', color: '#fff', cursor: 'pointer', fontSize: '0.875rem', fontWeight: 500 };
const BC = { padding: '6px 14px', borderRadius: 4, border: '1px solid #d1d5db', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: '0.875rem' };
const BE = { padding: '6px 12px', borderRadius: 4, border: 'none', backgroundColor: 'transparent', color: '#d32f2f', cursor: 'pointer', fontSize: '0.875rem' };

const Row = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: 'block', fontSize: '0.75rem', color: '#666', marginBottom: 3, fontWeight: 500 }}>{label}</label>
    {children}
  </div>
);

const AddHoursDialog = React.memo(function AddHoursDialog({
  open, onClose, addTarget, month, year,
  addCheckIn, setAddCheckIn, addCheckOut, setAddCheckOut,
  addH, addAmt, setAddAmt, addWorkRate, setAddWorkRate,
  addAutoAmt, addAllowanceAmt, addIncludeAllowance, setAddIncludeAllowance,
  addEff, addEx, addSaving, deleteManual, saveAddHours,
  projectList = [], addProjectId, setAddProjectId,
}) {
  if (!open) return null;
  return (
    <div style={OV} onClick={onClose}>
      <div style={MO} onClick={(e) => e.stopPropagation()}>
        <div style={MH}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
            <AddCircleOutlineIcon style={{ fontSize: 18, color: '#1976d2' }} />
            <span style={{ fontWeight: 600, fontSize: '1rem' }}>เพิ่มเวลาเข้า-ออกงาน</span>
          </div>
          {addTarget?.empName && <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>{addTarget.empName}</div>}
          <div style={{ fontSize: '0.75rem', color: '#9ca3af' }}>วันที่ {addTarget?.day}/{month + 1}/{year}</div>
        </div>

        <div style={MB}>
          <div style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
            <Row label="เวลาเข้างาน">
              <input type="time" value={addCheckIn} style={IS} onChange={(e) => setAddCheckIn(e.target.value)} />
            </Row>
            <Row label="เวลาออกงาน">
              <input type="time" value={addCheckOut} style={IS} onChange={(e) => setAddCheckOut(e.target.value)} />
            </Row>
          </div>

          {addH > 0 && (
            <div style={{ fontSize: '0.75rem', color: '#6b7280', marginBottom: 10, marginTop: -8 }}>
              รวม {addH % 1 === 0 ? addH : addH.toFixed(1)} ชม.
            </div>
          )}

          <Row label="โปรเจค">
            <select
              value={projectList.some((p) => String(p._id) === addProjectId) ? addProjectId : ''}
              style={{ ...IS, cursor: 'pointer' }}
              onChange={(e) => setAddProjectId(e.target.value)}
            >
              <option value="">— อัตโนมัติ (ตามโปรเจคล่าสุดของพนักงาน) —</option>
              {projectList.map((p) => (
                <option key={p._id} value={String(p._id)}>{p.project_number ? `${p.project_number} — ` : ''}{p.name}</option>
              ))}
            </select>
          </Row>

          <Row label="ค่าแรง (บาท) — ต่อวัน (8 ชม.)">
            <input type="number" value={addAmt} style={IS} onChange={(e) => setAddAmt(e.target.value)} />
            {addAmt === '' && (
              <div style={{ fontSize: '0.68rem', color: '#9ca3af', marginTop: 3 }}>
                ค่าเริ่มต้น ฿{(addAutoAmt ?? 0).toFixed(2)} (ค่าแรง 8 ชม. ของพนักงาน)
              </div>
            )}
          </Row>

          <Row label="อัตราค่าแรง">
            <select value={addWorkRate} style={{ ...IS, cursor: 'pointer' }} onChange={(e) => setAddWorkRate(Number(e.target.value))}>
              {WORK_RATE_OPTIONS.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
            </select>
          </Row>

          {addAllowanceAmt > 0 && (
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginBottom: 12, fontSize: '0.875rem' }}>
              <input type="checkbox" checked={addIncludeAllowance} onChange={(e) => setAddIncludeAllowance(e.target.checked)} />
              ให้เบี้ยเลี้ยง <strong>+฿{addAllowanceAmt.toFixed(2)}</strong>
            </label>
          )}

          {addH > 0 && (
            <div style={{ backgroundColor: '#e3f2fd', borderRadius: 4, padding: '8px 12px' }}>
              <span style={{ color: '#1976d2', fontWeight: 600, fontSize: '0.875rem' }}>
                ค่าแรงที่จะบันทึก: ฿{(addEff ?? 0).toFixed(2)}
                {addIncludeAllowance && addAllowanceAmt > 0 && (
                  <span style={{ color: '#0369a1', marginLeft: 6 }}>+ เบี้ยเลี้ยง ฿{addAllowanceAmt.toFixed(2)}</span>
                )}
              </span>
            </div>
          )}

          {addEx?.edited_by && (
            <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: 8 }}>บันทึกโดย: {addEx.edited_by}</div>
          )}
        </div>

        <div style={MF}>
          <div>{addEx && <button style={BE} onClick={deleteManual} disabled={addSaving}>ลบ</button>}</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={BC} onClick={onClose} disabled={addSaving}>ยกเลิก</button>
            <button style={{ ...BP, opacity: addSaving || addH <= 0 ? 0.6 : 1 }} onClick={saveAddHours} disabled={addSaving || addH <= 0}>
              {addSaving ? 'กำลังบันทึก...' : 'บันทึก'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});

export default AddHoursDialog;
